const customColors = {
  primary: {
    main: "#1565C0",
    light: "#42a5f5",
    dark: "#0d47a1",
    focus: "rgba(21, 101, 192, 0.08)",
  },
  secondary: {
    main: "#0f2c4a",
    light: "#5a6b85",
    dark: "#061D36",
    focus: "#f8f9fb",
  },
  success: {
    main: "#2e7d32",
    light: "#60ad5e",
    dark: "#005005",
    focus: "#e8f5e9",
  },
  warning: {
    main: "#FFC107",
    light: "#FFD54F",
    dark: "#FFB300",
    focus: "#FFF8E1",
  },
  error: {
    main: "#c62828",
    light: "#ff5f52",
    dark: "#8e0000",
    focus: "#ffebee",
  },
  gradient: {
    primary: "linear-gradient(135deg, #1565C0, #0d47a1)",
    secondary: "linear-gradient(135deg, #061D36 0%, #0f2c4a 100%)",
    header: "linear-gradient(135deg, #061D36 0%, #0f2c4a 100%)",
  },
};

export const primaryBtnSx = {
  background: "#FFC107 !important",
  bgcolor: "#FFC107 !important",
  color: "#061D36 !important",
  fontWeight: 700,
  boxShadow: "0 4px 14px rgba(255,193,7,0.25) !important",
  "&:hover": {
    background: "#FFB300 !important",
    bgcolor: "#FFB300 !important",
    boxShadow: "0 6px 18px rgba(255,193,7,0.35) !important",
  },
  "&:focus, &:focus:not(:hover), &.Mui-focusVisible": {
    background: "#FFC107 !important",
    bgcolor: "#FFC107 !important",
    color: "#061D36 !important",
    boxShadow: "0 4px 14px rgba(255,193,7,0.25) !important",
    outline: "none",
  },
};

export const navyBtnSx = {
  background: "#1a3a5c !important",
  bgcolor: "#1a3a5c !important",
  color: "#fff !important",
  fontWeight: 700,
  boxShadow: "none !important",
  "&:hover": {
    background: "#234a72 !important",
    bgcolor: "#234a72 !important",
    boxShadow: "none !important",
  },
  "&:focus, &:focus:not(:hover), &.Mui-focusVisible": {
    background: "#1a3a5c !important",
    bgcolor: "#1a3a5c !important",
    color: "#fff !important",
    boxShadow: "none !important",
    outline: "none",
  },
};

export const backBtnSx = {
  background: "#fff !important",
  bgcolor: "#fff !important",
  color: "#0f2c4a !important",
  border: "1px solid rgba(6, 29, 54, 0.15) !important",
  fontWeight: 600,
  boxShadow: "none !important",
  "&:hover": {
    background: "#f8f9fb !important",
    bgcolor: "#f8f9fb !important",
    borderColor: "#0f2c4a !important",
    boxShadow: "none !important",
  },
  "&:focus, &:focus:not(:hover), &.Mui-focusVisible": {
    background: "#f8f9fb !important",
    bgcolor: "#f8f9fb !important",
    color: "#0f2c4a !important",
    borderColor: "#0f2c4a !important",
    boxShadow: "none !important",
    outline: "none",
  },
};

export const outlineAccentBtnSx = {
  color: "#1565C0 !important",
  borderColor: "#1565C0 !important",
  fontWeight: 600,
  boxShadow: "none !important",
  "&:hover": {
    bgcolor: "rgba(21, 101, 192, 0.08) !important",
    borderColor: "#0d47a1 !important",
  },
  "&:focus, &:focus:not(:hover), &.Mui-focusVisible": {
    bgcolor: "rgba(21, 101, 192, 0.08) !important",
    color: "#1565C0 !important",
    borderColor: "#1565C0 !important",
    boxShadow: "none !important",
    outline: "none",
  },
};

export const infoAlertSx = {
  bgcolor: "rgba(21, 101, 192, 0.08)",
  color: "#0f2c4a",
  "& .MuiAlert-icon": { color: "#1565C0" },
};

export default customColors;
